module.exports = __webpack_public_path__ + "img/img2.758e786c.jpg";